// URL base do backend (injetada em build time pelo CRA)
const BACKEND_BASE = process.env.REACT_APP_BACKEND_URL || 'http://localhost:5000';

// URLs dos webhooks
export const WEBHOOK_INIT_URL = `${BACKEND_BASE}/webhook/purchase`;
export const WEBHOOK_CHECK_URL = `${BACKEND_BASE}/webhook/check-payment`;
export const WEBHOOK_ORDER_STATUS = `${BACKEND_BASE}/api/public/bookstats`;
// Configurações de polling
export const POLLING_INTERVAL = 5000; // 5 segundos
export const POLLING_TIMEOUT = 600000; // 10 minutos

// Configurações de processamento
export const PROCESSING_DURATION = 3000; // 3 segundos

// URLs base
export const BASE_URL = 'https://ebookarena.com.br';

// Timeouts e delays
export const COPY_FEEDBACK_DURATION = 2000;
export const ANIMATION_DURATION = 2000;